import { OpenFeature, useBooleanFlagValue } from '@openfeature/react-sdk';

import { FEATURE_FLAG_DOMAIN } from '@/features/flags/constants';

export const ROUTER_MONKEYPATCH_EHR_LAUNCH_KILLSWITCH =
  'killswitch-router-monkeypatch-for-ehrlaunch';

/**
 * Remote break-glass switch for the external EHR launch route namespace.
 * When enabled, the `/external` routing and navigation behavior is disabled.
 * This read is imperative because it runs outside a provider subtree.
 */
export const isRouterMonkeypatchForEhrLaunchKilled = (): boolean =>
  OpenFeature.getClient(FEATURE_FLAG_DOMAIN).getBooleanValue(
    ROUTER_MONKEYPATCH_EHR_LAUNCH_KILLSWITCH,
    false
  );

/** Reactive read for the app-wide navigation prefix hook. */
export const useIsRouterMonkeypatchForEhrLaunchKilled = (): boolean =>
  useBooleanFlagValue(ROUTER_MONKEYPATCH_EHR_LAUNCH_KILLSWITCH, false);
